import {
  VIEWING_COLUMN_NAME,
  VIEWING_MASS_ACTION,
} from '../../RentalPortalViewing'

export const QA_NAME_VIEWINGS_ADD_NEW = 'addNewViewing'

export const QA_NAME_VIEWINGS_CLEAR_FILTERS = 'viewingsClearFilters'

export const QA_NAME_VIEWINGS_PAGE = 'rentalPortalViewings'

export const QA_NAME_VIEWINGS_PREVIEW = 'viewingsPreview'

export const QA_NAME_VIEWINGS_REFRESH_ERROR = 'viewingsRefreshError'

export const QA_NAME_VIEWINGS_RETRY = 'viewingsRetry'

export const QA_NAME_VIEWINGS_TABLE = 'viewings'

export const VIEWINGS_FILTER_BAR_ITEMS_PROPS = { ShareTemplateButton: null }

export const VIEWINGS_INITIAL_RANGE_FILTER_NAMES = ['start']

export const VIEWINGS_PAGE_SIZE = 25

export const VIEWING_VIEW_REGIME = {
  calendar: 'calendar',
  split: 'split',
  table: 'table',
}

export const VIEWING_VIEW_REGIME_LABEL_KEY = {
  [VIEWING_VIEW_REGIME.calendar]: 'RentalPortal.ViewingViewCalendarKey',
  [VIEWING_VIEW_REGIME.split]: 'RentalPortal.ListingViewSplitKey',
  [VIEWING_VIEW_REGIME.table]: 'RentalPortal.ViewingViewTableKey',
}

export const VIEWINGS_TABLE_SKELETON_ROWS = 25

export const VIEWING_CREATE_ACTION_NAME = 'createViewing'

export const VIEWING_ACTION_ARCHIVE = 'archive'

export const VIEWING_ACTION_ARCHIVE_MASS = 'archiveMass'

export const VIEWING_ARCHIVE_UNDO_TIMEOUT = 8000

export const VIEWING_ACTION_RESTORE = 'restore'

// TODO: the epic declares no `viewings/mass-action/` endpoint, so the action
// names the request carries are unconfirmed

export const VIEWING_MASS_ACTION_NAMES = {
  [VIEWING_ACTION_ARCHIVE_MASS]: VIEWING_MASS_ACTION.archive,
}

export const VIEWING_ACTION_CREATE = 'create'

export const VIEWING_ACTION_OPEN = 'open'

export const VIEWING_ACTION_BOOK = 'book'

export const VIEWING_ACTION_CANCEL = 'cancel'

export const VIEWING_ACTION_RESCHEDULE = 'reschedule'

export const VIEWING_ACTION_PERMISSION_NAME = {
  [VIEWING_ACTION_ARCHIVE]: 'can_archive',
  [VIEWING_ACTION_BOOK]: 'can_manage',
  [VIEWING_ACTION_CANCEL]: 'can_manage',
  [VIEWING_ACTION_RESCHEDULE]: 'can_manage',
}

export const VIEWING_REQUIRED_COLUMNS = [
  VIEWING_COLUMN_NAME.DateTime,
  VIEWING_COLUMN_NAME.Status,
]
